import { ProposalHeaderImage } from './proposalHeaderImage.models';

export interface ProposalHeaderImageState {
  ids: string[];
  entities: Record<string, ProposalHeaderImage>;
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_PROPOSAL_HEADER_IMAGES' }
  | {
      type: 'FETCH_PROPOSAL_HEADER_IMAGES_SUCCESS';
      payload: { proposalHeaderImages: ProposalHeaderImage[] };
    }
  | {
      type: 'FETCH_PROPOSAL_HEADER_IMAGES_FAILURE';
      payload: { error: string };
    }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: ProposalHeaderImageState = {
  ids: [],
  entities: {},
  isLoaded: false,
  isLoading: false,
  error: null,
};

export const proposalHeaderImageReducer = (
  state: ProposalHeaderImageState,
  action: Action
): ProposalHeaderImageState => {
  switch (action.type) {
    case 'FETCH_PROPOSAL_HEADER_IMAGES':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_PROPOSAL_HEADER_IMAGES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.proposalHeaderImages.map(
              (a) => a.proposalHeaderImageId
            ),
          ]),
        ],
        entities: action.payload.proposalHeaderImages.reduce(
          (prev, curr) => ({ ...prev, [curr.proposalHeaderImageId]: curr }),
          state.entities
        ),
      };
    case 'FETCH_PROPOSAL_HEADER_IMAGES_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
